/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component, lazy, Suspense } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from '@vds/modals';

import { sendField, sendFieldEmulator } from './actions';
import { mycartNavbarHeight } from '../../assets/css/preprocess/global.scss';
import {
  getSession,
  isMoversFlow,
  getLTEUpgrade,
  isOCOFlow,
  isTablet,
  isMobile,
  viewport,
  isEUPFlow,
  isDesktopResolution,
  isComboFlow,
  isExternalFlow,
  isCPCCheckAvailabilityFlow,
  isFuncComp,
  isFooterRequired,
  // getCookie,
  getUrlName,
  isJointTransactionFlow,
} from './Helpers/index';
import { showPage } from '../../services/Cart/actions';
import { getPlansData } from '../../utils/plansReference';
import PageHeaderFWA from './PageHeaderFWA';
import PageBanner from './PageBanner';
import { getQueryParamByName } from './Helpers/queryParams';
import CallCradleAPI from './RequestAPI';

const StyledDiv = styled.div`
  text-align: center;
  width: 100%;
`;

const MobileCart = lazy(() => import('./MiniCart/redesign/mobileCart'));
const FuncMobileCart = lazy(() => import('./MiniCart/funComp/mobileCart'));

class PageHeader extends Component {
  constructor(props) {
    super(props);
    this.isMobile = isMobile();
    this.isTablet = isTablet();
    this.state = {
      showRepModal: false,
    };
  }

  componentDidMount() {
    const pageName = getUrlName(window.location.pathname);
    if (pageName === 'plansOverview') {
      CallCradleAPI('FWA_PlansOverview', pageName);
    }
  }

  showRepModal = () => {
    this.setState({
      showRepModal: true,
    });
  };

  repCloseModal = () => {
    this.setState({
      showRepModal: false,
    });
  };

  render() {
    const type = viewport();
    const isEmulator = false;
    const isInShell = true;
    const isACPEligibile = getQueryParamByName('acp') === 'y';
    const pageName = getUrlName(window.location.pathname);

    // const isCBandFlow = getSession('isCBandFlow');
    const isConfirmationPage = (this.props.currentView?.currentStep && this.props.currentView?.currentStep.toLowerCase() === 'confirmation') || false;
    const isExpressCartPage = (this.props.currentView?.currentStep && this.props.currentView?.currentStep.toLowerCase() === 'expresscart') || false;
    const isPlansOverviewPage = pageName === 'plansOverview' || false;
    const expresscartPath = pageName === 'expresscart' || false;
    const isBrtcPage = pageName === 'brtc' || false;
    const isCartView = (window.vzFlags?.vdsRedesign && pageName === 'cart') || false;

    const isRegistationPage = (this.props.currentView?.currentStep && this.props.currentView?.currentStep.toLowerCase() === 'registration') || false;
    const showMiniCart =
      (type === 'mfapp' || !isDesktopResolution()) &&
      (this.props.cartDetails || this.props.dueTodayList) &&
      !isConfirmationPage &&
      !isExpressCartPage &&
      !isBrtcPage &&
      !isMoversFlow() &&
      !isPlansOverviewPage &&
      !isRegistationPage &&
      !isJointTransactionFlow();
    const pageRef = document.getElementById('page');
    if (!showMiniCart) {
      pageRef.style.setProperty('--mycart-navbar-height', '0px');
    } else {
      pageRef.style.setProperty('--mycart-navbar-height', mycartNavbarHeight);
    }
    const ACPContent = this.props?.acpBannerContent;
    let isSpanishFlow = false;
    if (
      ACPContent &&
      this.props?.acpBannerSpanishContent &&
      (ACPContent.includes('Asequible') || ACPContent.includes('asequible')) &&
      ACPContent.includes('FCC')
    ) {
      isSpanishFlow = true;
    }

    return (
      <>
        {isFooterRequired() && <div id="vz-gh20" />}
        {!isFooterRequired() && (
          <div role="banner" id={!isPlansOverviewPage && (this.isMobile || this.isTablet || type === 'mfapp') ? 'progressbarSticky' : ''}>
            {' '}
            {type !== 'mfapp' && !expresscartPath && !isCPCCheckAvailabilityFlow() && !isComboFlow() && !isExternalFlow() && (
              <div>
                {!window.vzFlags?.isGnavEnabled && (
                  <div
                    id={isPlansOverviewPage && (this.isMobile || this.isTablet || type === 'mfapp') ? 'progressbarSticky' : ''}
                    className={`u-flexAlignItemsBaseline pad0 ${type === 'mfapp' ? 'mvaStretchContainer' : ''}`}
                    style={type === 'tablet' && isEUPFlow() === 'true' ? { marginTop: '30px', marginLeft: '15px' } : {}}
                  >
                    <PageHeaderFWA cradleValue={this.props.cradleValue} />
                  </div>
                )}
                {isPlansOverviewPage && this.props?.acpBannerFlag && !isACPEligibile && (
                  <div
                    className={`u-flexAlignItemsBaseline pad0 acpBannerPadding ${type === 'mfapp' ? 'mvaStretchContainer' : ''}`}
                    style={type === 'tablet' && isEUPFlow() === 'true' ? { marginTop: '30px', marginLeft: '15px' } : {}}
                  >
                    {isSpanishFlow ? (
                      <PageBanner acpBannerContent={this.props?.acpBannerSpanishContent} />
                    ) : (
                      <PageBanner acpBannerContent={this.props?.acpBannerContent} />
                    )}
                  </div>
                )}
              </div>
            )}
            <StyledDiv>
              {this.props.title}
              <React.Fragment>
                <Suspense fallback={<div />}>
                  {showMiniCart && (
                    <div
                      className="mvaContainer"
                      id={isPlansOverviewPage && (this.isMobile || this.isTablet || type === 'mfapp') ? 'progressbarSticky' : ''}
                    >
                      {!isFuncComp() ? (
                        <MobileCart
                          cartValueDetails={this.props.cartDetails}
                          pageStatus={(iscartVisibleVal) => showPage(iscartVisibleVal)}
                          isCartPageView={isCartView}
                          plansReferenceData={this.props.plansReferenceData}
                          history={this.props.history}
                          securityDepositAmt={this.props.securityDepositAmt}
                          taxFeeText={this.props.taxFeeText}
                          withAutoPayPreview={this.props.withAutoPayPreview}
                          withAutoPayTooltipDesc={this.props.withAutoPayTooltipDesc}
                        />
                      ) : (
                        <FuncMobileCart
                          pageStatus={(iscartVisibleVal) => showPage(iscartVisibleVal)}
                          isCartPageView={isCartView}
                          dueTodayAmount={this.props.dueTodayAmount}
                          dueTodayList={this.props.dueTodayList}
                          dueTodayTaxes={this.props.dueTodayTaxes}
                          shippingDetails={this.props.shippingDetails}
                          dueMontAmount={this.props.dueMontAmount}
                          dueMonthlyList={this.props.dueMonthlyList}
                          plansReferenceData={this.props.plansReferenceData}
                          getShowCartStatus={this.props.getShowCartStatus}
                          history={this.props.history}
                          dueTodayHomePhoneList={this.props.dueTodayHomePhoneList}
                          securityDepositAmt={this.props.securityDepositAmt}
                          ltePlans={this.props.ltePlans}
                          dueMonthlyProd={this.props.dueMonthlyProd}
                          depletionType={this.props.depletionType}
                          dueMonthlyTaxes={this.props.dueMonthlyTaxes}
                        />
                      )}
                    </div>
                  )}
                </Suspense>
              </React.Fragment>
            </StyledDiv>
            <div id={isPlansOverviewPage && (this.isMobile || this.isTablet || type === 'mfapp') ? 'progressbarSticky' : ''}>
              {isEmulator && !isInShell && (
                <div className="u-paddingRightExtraLarge u-textRight u-text30">
                  <span className="Icon Icon--close em-click-handle" onClick={() => this.showRepModal()} onKeyDown={this.showRepModal()} />
                </div>
              )}
              {isEmulator && !isInShell && this.state.showRepModal && (
                <Modal ariaLabel="CustomerDisclosure" opened={this.state.showRepModal} width="100%" showCloseButton={false}>
                  <ModalBody>
                    <div className="u-paddingRightExtraLarge u-textRight u-text30">
                      <span className="" onClick={() => this.repCloseModal()} onKeyDown={this.repCloseModal()} />
                    </div>
                  </ModalBody>
                </Modal>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const cartDetails = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const miniCartDetails = state.cartDetails ? state.cartDetails.miniCart : {};
  const miniCartError = state.cartDetails ? state.cartDetails.miniCartError : {};
  const isCartPageView = state.cartDetails ? state.cartDetails.isCartPageView : {};
  const currentView = state.currentView || {};
  const flowType = getSession('FlowType');
  const securityDepositAmt = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.fwaSecurityDepositAmount;
  const setup = state.deviceSetup.selectedOption && state.deviceSetup.selectedOption;

  const dueTodayAmount = state?.getCheckOutDetails?.orderDetails?.totalDueToday || 0;
  const dueTodayList = state?.getCheckOutDetails?.lineDetails?.lineInfo?.newLine1 || '';
  const dueTodayTaxes = state?.getCheckOutDetails?.orderDetails?.totalTaxAmount || 0;
  const shippingDetails = state?.getCheckOutDetails?.lineDetails?.lineInfo?.newLine1?.shippingItem || '';
  const dueMontAmount = state?.getCheckOutDetails?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo?.planPriceWithDiscount || 0;

  const dueMonthlyList = state?.getCheckOutDetails?.lineDetails?.subAccountNBSInfo?.[0]?.billAccounts?.[0]?.nbs?.monthlyChargesInfo || '';
  const dueMonthlyProd = state?.getCheckOutDetails?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo || '';
  const dueMonthlyTaxes = state?.getCheckOutDetails?.orderDetails?.totalMonthlyTaxes || 0;
  const dueTodayHomePhoneList = state?.getCheckOutDetails?.lineDetails?.lineInfo?.newLine2;

  const ltePlans = state?.homePlans ? state?.homePlans?.plansJson : '';
  const depletionType = state?.getCheckOutDetails?.depletionType || '';

  // Removed Schedule support as per the NSADT-99052
  // when user is selected professional setup, the schedule header should be enabled
  if (setup === 'SELF') {
    delete state.progressSteps['Schedule']; //eslint-disable-line
  }
  if ((flowType === 'LTE' || getLTEUpgrade()) && state.progressSteps) {
    if (getLTEUpgrade()) {
      delete state.progressSteps['Add-Ons']; //eslint-disable-line
    }
    delete state.progressSteps['Schedule']; //eslint-disable-line
  }
  if (isOCOFlow() !== undefined && isOCOFlow() === 'true' && state.progressSteps) {
    delete state.progressSteps['Add-Ons']; //eslint-disable-line
  }
  if (flowType === 'LTE' && state.progressStepsMV) {
    delete state.progressStepsMV['Schedule']; //eslint-disable-line
  }
  const progress = state.progressSteps || [];
  const progressMV = state.progressStepsMV || [];
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const cradleValue = state?.SessionValues?.signInCradleValue;

  return {
    urlExtracts: state.UrlExtractsReducer,
    cartDetails,
    isCartPageView,
    progressSteps: progress,
    progressStepsMV: progressMV,
    plansReferenceData,
    currentView,
    securityDepositAmt,
    miniCartDetails,
    miniCartError,
    dueTodayAmount,
    dueTodayList,
    dueTodayTaxes,
    shippingDetails,
    dueMontAmount,
    dueMonthlyList,
    dueMonthlyProd,
    dueMonthlyTaxes,
    dueTodayHomePhoneList,
    ltePlans,
    depletionType,
    cradleValue,
  };
};

const mapDispatchToProps = {
  sendFieldEmulator,
  sendField,
};

PageHeader.propTypes = {
  title: PropTypes.string,
  cartDetails: PropTypes.object,
  plansReferenceData: PropTypes.object,
  history: PropTypes.object,
  currentView: PropTypes.object,
  securityDepositAmt: PropTypes.any,
  acpBannerContent: PropTypes.string,
  acpBannerSpanishContent: PropTypes.string,
  acpBannerFlag: PropTypes.bool,
  taxFeeText: PropTypes.string,
  dueTodayAmount: PropTypes.number,
  dueTodayList: PropTypes.object,
  dueTodayTaxes: PropTypes.number,
  shippingDetails: PropTypes.string,
  dueMontAmount: PropTypes.number,
  dueMonthlyList: PropTypes.string,
  getShowCartStatus: PropTypes.string,
  dueTodayHomePhoneList: PropTypes.array,
  ltePlans: PropTypes.string,
  dueMonthlyProd: PropTypes.object,
  depletionType: PropTypes.any,
  dueMonthlyTaxes: PropTypes.number,
  cradleValue: PropTypes.string,
  withAutoPayPreview: PropTypes.string,
  withAutoPayTooltipDesc: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageHeader);
